/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { action, observable } from 'mobx';
import { OmitFunctions } from 'src/core/stores/types';
import { CharRange } from 'src/modules/labeling/types';

/**
 * Azure Blob data type.
 */
export type AzureBlobData = OmitFunctions<Omit<AzureBlobStore, 'id'>>;
export type AzureBlobContent = { text: string; tokenRanges: CharRange[] };

/**
 * Represents an Azure Blob.
 */
export class AzureBlobStore {
    public readonly id: string;

    public readonly name: string;

    public readonly size: number;

    public readonly blobType: string;

    public readonly creationDate: Date;

    public readonly modificationDate: Date;

    @observable public content: AzureBlobContent;

    constructor(id: string, azureBlobData: Partial<AzureBlobData>) {
        this.id = id;
        this.name = azureBlobData.name;
        this.size = azureBlobData.size;
        this.content = azureBlobData.content;
        this.blobType = azureBlobData.blobType;
        this.creationDate = azureBlobData.creationDate;
        this.modificationDate = azureBlobData.modificationDate;
    }

    /**
     * Sets the blob content.
     */
    @action
    public setContent(content: AzureBlobContent) {
        this.content = content;
    }
}
